import {React} from "react";
import {Link} from "react-router-dom";
import BouncyCardsFeatures from "./components/bouncyCardsFeatures";
import { ButtonDrawOutline } from "../../components/common";

const Inserr = () => {
    return(
        <div>
            <div class="sticky -z-10"></div>
            <div class="lg:grid lg:grid-cols-2">
                <div class="" >
                <img src={require("../../assets/img/inserr/IMG_5224.JPG")} alt="INSERR" class=" w-screen lg:w-[50vw] object-cover overflow-hidden" />
                </div>
                <div class=" justify-center  items-center ">
                    <div class="my-10 lg:my-0 text-center justify-center items-center h-full w-5vw content-center">
                    <h1 class="text-7xl">INSERR</h1>
                    <p class="lg:text-xl">World's first underwater robot with life-saving equipment</p>
                    </div>
                </div>
            </div>
            <div class="lg:grid lg:grid-cols-2">
                    <div class="text-center justify-center flex items-center h-full w-5vw content-center">
                    <h1 class=" hidden lg:block lg:m-10 p-10 sm:text-lg lg:text-5xl">World's first underwater robot with life-saving equipment</h1>
                </div>
                <div class="">
                    <img src={require("../../assets/img/inserr/IMG_5242.JPG")} alt="INSERR" class=" w-screen lg:w-[50vw] object-cover overflow-hidden" />
                </div>
            </div>
            
            <div class="flex lg:h-screen justify-center items-center content-center bg-gradient-to-r from-green-500 to-teal-900">
            <div class="text-2xl lg:text-4xl p-10 m-10 w-4/5 text-white">
            <p class="font-bold bold mb-5">Introducing INSERR:</p>
            <p>                 
                a groundbreaking Remotely Operated Vehicle (ROV) engineered to revolutionize underwater rescue operations. Designed for zero-visibility environments, INSERR combines advanced navigation systems with life-sustaining equipment to enhance disaster response and save lives. 
            </p>
            </div>
            </div>
            <div class="py-20">
            <BouncyCardsFeatures />
            </div>
            <h1 class="text-5xl text-bold p-5 mt-10 m-5">Applications</h1>
            <div class="flex justify-center items-center content-center w-full">
            <dl class=" text-xl lg:text-2xl p-10 m-10 w-4/5 list-disc">
                <dt class="font-bold">Disaster Response:</dt>
                <dd class="mb-3">Rapid deployment in flood and underwater disaster scenarios to locate and assist victims.  </dd>
                <dt class="font-bold">Search and Rescue:</dt>
                <dd class="mb-3">Efficiently conducts search operations in zero-visibility waters, providing real-time data to rescue teams.  </dd>
                <dt class="font-bold"> Environmental Monitoring:</dt>
                <dd class="mb-3">Collects critical data in challenging conditions, aiding in environmental assessments and research. </dd>

            </dl>
            </div>
            <div class=" text-white h-auto lg:h-screen w-screen justify-center items-center content-center bg-gradient-to-r from-teal-900 to-green-500">
            <div>
            <h1 class="text-5xl font-bold p-5 mt-10 m-5">Why Choose INSERR? </h1>
            <p class="text-lg lg:text-2xl p-10 m-10">
            INSERR sets a new standard in underwater rescue technology by integrating life-sustaining capabilities with advanced navigation systems. Its modular design allows for customization to meet specific mission requirements, making it an indispensable tool for emergency responders and environmental agencies.

            Experience the future of underwater rescue with INSERR—where innovation meets lifesaving performance. 
            </p>
            <div class=" ml-10 mb-10">
            <Link to={"/contact"} class="py-2 px-4 ">
                    <ButtonDrawOutline>Get In Touch With Us →</ButtonDrawOutline>
                </Link></div>
            </div>
            </div>
        </div>
    )
}

export default Inserr;